export default () => ({
  legacy: false,
  locale: "en",
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  fallbackWarn: false,
  missingWarn: false
});
